import ApiService from "./ApiService"

export async function getEmployeeStatistics(data) {
    return ApiService.fetchData({
        url: 'employee/getEmployeeStatistics',
        method: 'post',
        data
    })
}



